import React, { useMemo, useState } from 'react';
import { Typography, Alert, Button, notification } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { getExchangeEvaluationPdfUrl } from '../../../../services/admin-services';

const { Title } = Typography;

const ExchangeStages = ({ leadViewDetails }) => {
  const exchangeStages = leadViewDetails?.exchange_stage_history || [];
  const leadId = leadViewDetails?.id;
  const [downloading, setDownloading] = useState(false);

  const isEvaluationCompleted = useMemo(() => {
    return exchangeStages?.some(
      (s) => s?.stage?.id === 5 && s?.status === 2
    );
  }, [exchangeStages]);

  const handleDownload = async () => {
    try {
      setDownloading(true);
      const response = await getExchangeEvaluationPdfUrl(leadId);
      const url = typeof response?.data?.data === 'string'
        ? response.data.data
        : (response?.data?.data?.url || response?.data?.url);
      if (!url) {
        notification.error({ message: 'Download URL not found' });
        return;
      }
      notification.success({
        message: response?.data?.message || 'Download started.',
      });
      setTimeout(() => {
        window.open(url, '_blank', 'noopener');
      }, 800);
    
    } catch (error) {
      notification.error({ message: 'Failed to fetch PDF URL' });
    } finally {
      setDownloading(false);
    }
  };

  // Hide component when exchange_car exists
  if (leadViewDetails?.exchange_car ==="No") {
    return null;
  }

  if (exchangeStages.length === 0) {
    return (
      <div style={{ marginBottom: '20px' }}>
        <Alert
          message="No stages available"
          description="Exchange stages are not configured for this lead."
          type="warning"
          showIcon
        />
      </div>
    );
  }

  return (
    <div style={{ 
      marginBottom: '25px', 
      padding: '20px', 
      backgroundColor: '#ffffff', 
      borderRadius: '12px',
      border: '1px solid #e1e5e9',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        marginBottom: '18px',
        gap: '10px',
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '4px',
            height: '20px',
            backgroundColor: '#1890ff',
            borderRadius: '2px'
          }}></div>
          <Title level={5} style={{ margin: 0, color: '#262626', fontWeight: '600' }}>
            Exchange Stages
          </Title>
        </div>

        {isEvaluationCompleted && (
          <Button
            type="primary"
            className="secondary-button reports-download-button"
            icon={<DownloadOutlined />}
            onClick={handleDownload}
            loading={downloading}
          >
            Download
          </Button>
        )}
      </div>
      
      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
        {exchangeStages.map((stageItem, index) => {
          const isCompleted = stageItem.status === 2; // 2 = Completed
          const isCurrent = stageItem.status === 1; // 1 = In Progress
          
          return (
            <div
              key={stageItem.id}
              style={{
                padding: '10px 18px',
                borderRadius: '25px',
                fontSize: '13px',
                fontWeight: '500',
                backgroundColor: isCompleted ? '#52c41a' : isCurrent ? '#ffc53d' : '#f5f5f5',
                color: isCompleted || isCurrent ? 'white' : '#8c8c8c',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                minWidth: 'fit-content',
                border: isCompleted || isCurrent ? 'none' : '1px solid #d9d9d9',
                transition: 'all 0.3s ease',
                cursor: 'default'
              }}
            >
              <div style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                backgroundColor: isCompleted || isCurrent ? 'rgba(255,255,255,0.3)' : '#d9d9d9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '10px',
                fontWeight: 'bold'
              }}>
                {isCompleted ? '✓' : isCurrent ? '●' : index + 1}
              </div>
              {stageItem.stage.name}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExchangeStages;
